import React from 'react';

import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import { types } from 'constants/vesselTypes';

class TypeByPurpose extends React.Component {
    onChange = value => {
        const { changeField, fromTcOrder } = this.props;

        const toChange = [
            { field: 'typeByPurpose', value },
        ];

        if (fromTcOrder) {
            toChange.push(
                fromTcOrder && !['MPP', 'PASSCAR'].includes(value) && { field: 'linerMeterMin', value: null },
                fromTcOrder && !['MPP', 'PASSCAR'].includes(value) && { field: 'linerMeterMax', value: null },
                fromTcOrder && !['MPP', 'CONT'].includes(value) && { field: 'teuMin', value: null }, 
                fromTcOrder && !['MPP', 'CONT'].includes(value) && { field: 'teuMax', value: null }
            );
        } else {
            !['MPP', 'PASSCAR'].includes(value) && toChange.push({ field: 'linerMeter', value: null });
        }

        changeField(toChange);
    };

    render() {
        const { getError, confirmed, type, modifiedFields, purposeErrorField, underStyle } = this.props;

        return (
            <SelectField
                value={type}
                disabled={confirmed}
                onChange={(e, index, value) => this.onChange(value)}
                maxHeight={200}
                name='typeByPurpose'
                floatingLabelText='Type By Purpose'
                errorText={getError && getError('typeByPurpose')}
                fullWidth
                input={<input required/>}
                required
                underlineStyle={purposeErrorField && purposeErrorField.hasOwnProperty('borderColor') ? purposeErrorField :  modifiedFields && modifiedFields.includes('typeByPurpose') ? underStyle : null}
                floatingLabelStyle={purposeErrorField && purposeErrorField.hasOwnProperty('borderColor') ? {color: purposeErrorField.borderColor} : null}
            >
                {
                    types.map((type, i) => {
                        return (<MenuItem
                            key={i}
                            value={type}
                            primaryText={type}
                        />);
                    })
                }
            </SelectField>
        );
    }
}

export default TypeByPurpose;


// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/TypeByPurpose.jsx